<div class="skeleton-container">
  <div class="skeleton-item">
    <div class="icon-skeleton"></div>
    <div class="text-skeleton"></div>
  </div>
  <div class="icon-skeleton"></div>
</div>
